import React, { ReactElement } from 'react';

import styles from './MainFrame.module.scss';
import { IMainFrameProps } from './MainFrame.types';

function MainFrame({ children }: IMainFrameProps): ReactElement {
  return (
    <main className={styles.root} data-testid="MainFrame">
      {children}
    </main>
  );
}

export default MainFrame;
